import $ from 'jquery';
import {Swiper, EffectFade} from 'swiper/js/swiper.esm.js';

Swiper.use([EffectFade])

$('.section--industries').each(function () {
    const $self = $(this);
    const $slider = $self.find('.swiper-industries');
    const industriesSwiper = new Swiper($slider[0], {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        }
    });

    const $accordions = $self.find('.industry-accordion');

    $accordions.each(function () {
        const $accordion = $(this);
        const $button = $accordion.find('.industry-accordion__title');

        $button.click(function () {
            $accordions.removeClass('active');
            $accordion.addClass('active');
            industriesSwiper.slideTo(Number($button.attr('data-slide')) + 1);
        });
    });
});

